var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-wrapper"},[_c('GoodsList',{attrs:{"isRequestingPackageList":_vm.isLoading,"goodList":_vm.list,"checkList":_vm.checkList,"moneyUnit":_vm.moneyUnit,"activityData":_vm.activityData},on:{"goodItemClick":function($event){return _vm.$emit('goodItemClick', $event)}}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }